import {
  addAllEventDetails,
  addEventDetails,
  setOngoingJoinedEventIds,
  setOngoingMyEventIds,
  setPastMyEventIds,
  setUpcomingJoinedEventIds,
  setUpcomingMyEventIds,
} from "modules/event/eventSlice";
import useSystemClock from "modules/system/hooks/useSystemClock";
import {
  getJoinedEvents,
  getOngoingEvents,
  getPastEvents,
  getUpcomingEvents,
} from "services/apiService/apis";
import { useAppDispatch } from "store/hooks";

export const usePopulateEventData = () => {
  const { deviation } = useSystemClock();
  const dispatch = useAppDispatch();

  const retrieveUpcomingMyEvents = async (companyId: string) => {
    const resp = await getUpcomingEvents(companyId);

    if (resp.isSuccess) {
      dispatch(addAllEventDetails(resp.events));
      const eventIds = resp.events.map((event) => `${event.id}`);

      dispatch(setUpcomingMyEventIds(eventIds));
    }
  };
  const retrieveOngoingMyEvents = async (companyId: string) => {
    const resp = await getOngoingEvents(companyId);

    if (resp.isSuccess && resp.events) {
      dispatch(addAllEventDetails(resp.events));
      const eventIds = resp.events.map((event) => `${event.id}`);

      dispatch(setOngoingMyEventIds(eventIds));
    }
  };

  const retrievePastMyEvents = async (id: string) => {
    const resp = await getPastEvents(id);

    if (resp.isSuccess && resp.events) {
      dispatch(addAllEventDetails(resp.events));
      const eventIds = resp.events.map((event) => `${event.id}`);

      dispatch(setPastMyEventIds(eventIds));
    }
  };

  const retrieveJoinedEvents = async () => {
    const serverTime = Date.now() + deviation;
    const resp = await getJoinedEvents(serverTime);

    if (resp.isSuccess && resp.upcomingEvents && resp.ongoingEvents) {
      resp.upcomingEvents.forEach((eventData) => {
        dispatch(addEventDetails(eventData));
      });
      const upcomingEventIds = resp.upcomingEvents.map(
        (event) => event.id as string,
      );

      dispatch(setUpcomingJoinedEventIds(upcomingEventIds));

      resp.ongoingEvents.forEach((eventData) => {
        dispatch(addEventDetails(eventData));
      });
      const ongoingEventIds = resp.ongoingEvents.map(
        (event) => event.id as string,
      );

      dispatch(setOngoingJoinedEventIds(ongoingEventIds));
    }
  };

  return {
    getUpcomingMyEvents: retrieveUpcomingMyEvents,
    getPastMyEvents: retrievePastMyEvents,
    getOngoingMyEvents: retrieveOngoingMyEvents,
    getJoinedEvents: retrieveJoinedEvents,
  };
};
